<div
  class="parking-card"
  [ngClass]="policyClass"
  role="button"
  [attr.tabindex]="card.unavailable ? -1 : 0"
  [attr.aria-disabled]="card.unavailable ? true : null"
  i18n-aria-label="@@chatParkingSelect"
  aria-label="Select {{ card.name }}"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  (keydown.space)="onCardClick()"
>
  @if (policyLabel) {
    <span class="visuallyhidden">{{ policyLabel }}</span>
  }
  <div class="parking-card__body">
    <!-- ENT-16273: car icon in a soft square, matching the mockup. -->
    <span class="parking-card__icon">
      <fa-icon [icon]="faCar"></fa-icon>
    </span>
    <div class="parking-card__main">
      <!-- ENT-16273: car-park name is the card headline (the drop-off → pick-up range now
           lives in the group header above). -->
      <div class="parking-card__name">
        {{ card.name }}
        @if (card.terminal) {
          <span i18n="@@chatParkingTerminal">Terminal</span> {{ card.terminal }}
        }
      </div>

      @if (card.onAirport !== undefined) {
        <div class="parking-card__location-type" [class.is-off]="!card.onAirport">
          <span class="parking-card__location-icon">{{ card.onAirport ? '✓' : '·' }}</span>
          @if (card.onAirport) {
            <span i18n="@@chatParkingOnAirport">On-airport parking</span>
          } @else {
            <span i18n="@@chatParkingOffAirport">Off-airport parking</span>
          }
        </div>
      }

      <!-- ENT-16273: transfer/shuttle info — clock icon + "Transfers run every X mins",
           matching the mockup (no transfer-duration text). Shown only when the feed
           gives a shuttle frequency. -->
      @if (card.transferFrequency && card.transferFrequency !== '0') {
        <div class="parking-card__transfer">
          <fa-icon [icon]="faClock" class="parking-card__transfer-icon"></fa-icon>
          <span i18n="@@pnltransfersRun">Transfers run</span>
          <span i18n="@@pnlEvery">every</span> {{ card.transferFrequency }}
          <span i18n="@@chatParkingMins">mins</span>
        </div>
      }

      <div class="parking-card__meta">
        @if (card.isPreferred) {
          <span class="parking-card__preferred" i18n="@@chatParkingPreferred">Preferred</span>
        }
      </div>

      <!-- Policy indicator: same component/tooltip as the results page. -->
      <app-warning-tags
        [ticket]="headlineWarningTicket"
        [displayCheck]="false"
        (click)="$event.stopPropagation()"
      ></app-warning-tags>
    </div>

    <div class="parking-card__price-col">
      @if (!card.unavailable) {
        <span class="parking-card__price-label" i18n="@@totalPrice"> Total Price </span>
        <span class="parking-card__price">{{ formattedPrice }}</span>
      } @else {
        <span class="parking-card__unavailable-label" i18n="@@chatParkingUnavailableShort"
          >Unavailable</span
        >
      }
    </div>
  </div>
</div>
